import { ReadBookButton, BuyNowButton, ReadFreeBookButton } from '@!/Store/Common/components/BookList/Button'

export const PrimaryActionButton = ({ content }) => {
  return (
    <>
      {content.purchased ? (
        <ReadBookButton content={content} />
      ) : content.price === 0 ? (
        <ReadFreeBookButton content={content} />
      ) : (
        <BuyNowButton content={content}>今すぐ購入する</BuyNowButton>
      )}
    </>
  )
}
